export default "__VITE_ASSET__hQ9fRqVV__"